import {
  SidebarMenu,
  SidebarMenuItem,
  useSidebar,
} from "@/components/shadcn/sidebar"

import { Icon } from '@iconify-icon/solid';
import { createSignal, For, Show } from "solid-js"
import { Button } from "@/components/shadcn/Button";

export function Brand(props) {
  const { isMobile, state, toggleSidebar } = useSidebar();

  const togglerIcon = () => {
    if (state() === 'collapsed') {
      return "heroicons-solid:chevron-double-right";
    } else {
      return "heroicons-solid:chevron-double-left";
    }
  }

  const togglerVariant = () => {
    if (state() === 'collapsed') {
      return "ghost"
    } else {
      return "outline"
    }
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div class="flex items-center justify-between px-2">
          <div>
            <Show when={state() !== 'collapsed'}>
              <img src={"/assets/images/logo.png"} alt={"Solana logo"} class="h-8 w-auto" />
            </Show>
          </div>
          <Button size="icon" variant={togglerVariant()} onClick={() => { toggleSidebar() }} ><Icon icon={togglerIcon()} /></Button>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
